<template>

</template>

<script>
const date = new Date();
const years = date.getFullYear();
const month = date.getMonth() + 1;
let start_select_time = new Date(years, 7, 26);
const end_select_time = new Date(years, 12, 30);
let grade = years;
let grades = [];
if (month > 7) {
  grade = years;
  grades = [years - 1, years];
} else {
  start_select_time = new Date(years, 0, 1);
  grade = years - 1;
  grades = [years - 2, years - 1];
}
export default {
  name: "Global",
  start_select_time,
  end_select_time,
  years,
  month,
  grade,
  grades
}
</script>

<style scoped>

</style>
